var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('p',{staticClass:"text-center mx-auto"},[_vm._v("Signing you out, please wait ...")])])}
var staticRenderFns = []

export { render, staticRenderFns }